// extracted by mini-css-extract-plugin
export default {"tabs_wrap":"Tabs_tabs_wrap__Vb7Pj","radio_group":"Tabs_radio_group__aQgIs","radio_btn":"Tabs_radio_btn__MqlhM"};